import { useMemo } from 'react';
import { CurrentUser } from '../types';
import { filterMobileRestrictedWorkflowTypes } from '../utils/mobileRestrictions';
import { canCreateWorkflowType } from '../utils/permissions';
import { getAllWorkflows } from '../utils/workflowRegistry';

// ============= Hook =============
/**
 * Custom hook to manage workflow permissions and allowed workflow types
 * Extracts permission logic from BodyLayout
 */
export const useWorkflowPermissions = (currentUser: CurrentUser | null) => {
  const allowedWorkflowTypes = useMemo(
    () => currentUser?.canCreateWorkflowTypes || [],
    [currentUser?.canCreateWorkflowTypes]
  );

  const allowedWorkflowTypeEnums = useMemo(() => {
    const mappedTypes = getAllWorkflows()
      .map((workflow) => workflow.workflowType)
      .filter((workflowType) =>
        canCreateWorkflowType(currentUser, workflowType)
      );

    return filterMobileRestrictedWorkflowTypes(mappedTypes);
  }, [currentUser]);

  return {
    allowedWorkflowTypes,
    allowedWorkflowTypeEnums,
  };
};
